<template>
  <div class="container-fluid" id="result">
    <div class="row wrapper">
      <div class="col-12 col-md-4 d-print-none">
        <div class="header">
          <div id="steps" class="steps" tabindex="0" role="document">
            <span>Step 5</span> of 5
          </div>
          <h1 tabindex="0">Your insurance needs</h1>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>

      <div class="col-12 col-md-8">
        <div class="main">
			<!-- Print only   -->
			<div class="d-none d-print-block print-result mt-4 mb-5">
				<h1>
					Your insurance needs result
				</h1>
				<p>
					These results are subject to the limitations set out in and assumptions used by the calculator. When considering these results, you should ensure that you understand the limits and assumptions.
					<br><br>
					These results are printed on <strong>{{ new Date().toDateString() }} </strong> and are valid for 30 days after printing.
				</p>
				<h2>
					Your input
				</h2>
				<table class="table table-striped">
					<tbody>
						<tr>
							<td>Age</td>
							<td>{{this.data.stepData.age}}</td>
						</tr>
						<tr>
							<td>Family type</td>
							<td>
								<div v-if="this.data.stepData.familyType == 'Single'">Single</div>
								<div v-if="this.data.stepData.familyType == 'Couple'">Couple</div>
								<div v-if="this.data.stepData.familyType == 'Single_Dependant'">Single with {{this.dependants.length}} dependant(s)</div>
								<div v-if="this.data.stepData.familyType == 'Couple_Dependant'">Couple with {{this.dependants.length}} dependant(s)</div>
							</td>
						</tr>
						<tr>
							<td>Accommodation expenses</td>
							<td>
								<span v-if="this.data.stepData.homeType == 'None'">-</span>
								<span v-if="this.data.stepData.homeType == 'Mortgage'">Mortgage of ${{formatCurrency(this.data.stepData.mortgageAmount)}}</span>
								<span v-if="this.data.stepData.homeType == 'Rent'">Rent of ${{formatCurrency(this.data.stepData.rentAmount)}} / Week</span>
							</td>
						</tr>
						<tr>
							<td>Salary</td>
							<td>
								<span v-if="this.data.stepData.salaryPeriod === 'Month'">${{formatCurrency(this.data.stepData.salaryMonthly)}}</span>
								<span v-if="this.data.stepData.salaryPeriod === 'Week'">${{formatCurrency(this.data.stepData.salaryWeekly)}}</span>
								<span v-if="this.data.stepData.salaryPeriod === 'Year'">${{formatCurrency(this.data.stepData.salaryYearly)}}</span>
								/ {{this.data.stepData.salaryPeriod}}
							</td>
						</tr>
						<tr>
							<td>Savings</td>
							<td>${{formatCurrency(this.data.stepData.savings)}} </td>
						</tr>
						<tr>
							<td>Debt</td>
							<td>
								<div v-if="this.debts && this.debts.length != 0" >
									<div v-for="(n, ind) in this.debts" :key="'debts'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount)}}</span>
									</div>
								</div>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Assets</td>
							<td>
								<div  v-if="this.assets && this.assets.length != 0">
									<div v-for="(n, ind) in this.assets" :key="'assets'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount)}}</span>
									</div>
								</div>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Living expenses</td>
							<td>
								<div v-if="detailedExpenses">
									<div v-for="(n, ind) in this.expenses" :key="'expenses'+ind">
										<span v-if="n.Amount > 0">{{n.Name}} : ${{formatCurrency(n.Amount)}}</span>
									</div>
									<hr>
									Total: ${{formatCurrency(this.livingExpenses)}} / Month
								</div>
								<div v-else>
									${{formatCurrency(this.data.stepData.expensesAmountPerMonth)}} / Month
								</div>

							</td>
						</tr>
						<tr>
							<td>Education expenses per year</td>
							<td>
								<ul v-if="this.data.stepData.familyType == 'Single_Dependant' || this.data.stepData.familyType == 'Couple_Dependant'">
									<li v-for="(n, ind) in this.dependants" :key="'dependants'+ind">
										<span v-if="n.Amount > 0">For dependant age {{n.Age}} : ${{formatCurrency(n.Amount)}}</span>
									</li>
								</ul>
								<div v-else>
									-
								</div>
							</td>
						</tr>
						<tr>
							<td>Disability expenses</td>
							<td>${{formatCurrency(this.data.stepData.disabilityCost)}} </td>
						</tr>
						<tr>
							<td>Funeral expenses</td>
							<td>${{formatCurrency(this.data.stepData.funeralExpenses)}} </td>
						</tr>

					</tbody>
				</table>

			</div>
			<!-- end Print only -->
			<p>{{pageContent.pages.results.introText}}</p>
          <!-- {{graphData}} -->
          <div class="accordion" id="result-accordion" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 tabindex="0" variant="result">
                  <div class="title">Death cover</div>
                  <div class="number" v-if="this.engineResults.LifeInsurance">${{formatCurrency(Math.max(Math.round(this.engineResults.LifeInsurance.LifeInsuranceNeed),0), true)}}</div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-1" class="d-print-block" v-if="this.engineResults.LifeInsurance" accordion="my-accordion" role="tabpanel" v-bind:class="{ 'hide-graph': this.engineResults.LifeInsurance.LifeInsuranceNeed <= 0 }">
                <b-card-body>
                  <b-card-text>
                    <p class="no-insurance-summary" v-html="pageContent.pages.results.deathCoverNotRequiredSummary"></p>
                    <div class="insurance-summary">
                      <p>{{pageContent.pages.results.deathCoverSummary}}</p>
                      <div class="row">
                        <div class="col-6">
                          <div class="coin-wrapper" aria-hidden="true">
                            <div class="progress">
                              <div class="progress-bar bg-none" role="progressbar"></div>
                              <div class="progress-bar bg-legend-4" role="progressbar" v-for="n in this.graphData.DeathDebtCoin" :key="'debt'+n"></div>
                              <div class="progress-bar bg-legend-3" role="progressbar" v-for="n in this.graphData.DeathEducationCoin" :key="'education'+n"></div>
                              <div class="progress-bar bg-legend-2" role="progressbar" v-for="n in this.graphData.DeathLivingCoin" :key="'living'+n"></div>
                              <div class="progress-bar bg-legend-1" role="progressbar" v-for="n in this.graphData.DeathFuneralCoin" :key="'funeral'+n"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 legend-wrapper">
                          <div class="legend">
                            <div class="item-1" v-if="this.graphData.DeathFuneralCoin > 0"><span class="swatch"></span>Funeral expenses  ({{this.graphData.DeathFuneralPerc}}%)</div>
                            <div class="item-2" v-if="this.graphData.DeathLivingCoin > 0"><span class="swatch"></span>Living expenses<span v-if="this.data.stepData.rentAmount > 0"> including rent </span> ({{this.graphData.DeathLivingPerc}}%) </div>
                            <div class="item-3" v-if="this.graphData.DeathEducationCoin > 0"><span class="swatch"></span>Education cost  ({{this.graphData.DeathEducationPerc}}%)</div>
                            <div class="item-4" v-if="this.graphData.DeathDebtCoin > 0"><span class="swatch"></span>Mortgage and/or debts ({{this.graphData.DeathDebtPerc}}%)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-2 tabindex="0" variant="result">
                  <div class="title">Total and Permanent Disability (TPD) cover</div>
                  <div class="number" v-if="this.engineResults.TPDInsurance">${{formatCurrency(Math.max(Math.round(this.engineResults.TPDInsurance.TPDInsuranceNeed),0), true)}}</div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-2" class="d-print-block" v-if="this.engineResults.TPDInsurance" accordion="my-accordion" role="tabpanel" v-bind:class="{ 'hide-graph': this.engineResults.TPDInsurance.TPDInsuranceNeed <= 0 }">
                <b-card-body>
                  <b-card-text>
                    <p class="no-insurance-summary" v-html="pageContent.pages.results.tpdCoverNotRequiredSummary"></p>
                    <div class="insurance-summary">
                      <p>{{pageContent.pages.results.tpdcoverSummary}}</p>
                      <div class="row">
                        <div class="col-6">
                          <div class="coin-wrapper" aria-hidden="true">
                            <div class="progress">
                              <div class="progress-bar bg-none" role="progressbar"></div>
                              <div class="progress-bar bg-legend-1" role="progressbar" v-for="n in this.graphData.TPDMortgageCoin" :key="'mortgage'+n"></div>
                              <div class="progress-bar bg-legend-2" role="progressbar" v-for="n in this.graphData.TPDDebtCoin" :key="'debt'+n"></div>
                              <div class="progress-bar bg-legend-3" role="progressbar" v-for="n in this.graphData.TPDDisabilityCoin" :key="'disability'+n"></div>
                              <div class="progress-bar bg-legend-4" role="progressbar" v-for="n in this.graphData.TPDFutureCoin" :key="'future'+n"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 legend-wrapper">
                          <div class="legend">
                            <div class="item-4" v-if="this.graphData.TPDFutureCoin > 0"><span class="swatch"></span>Income supplement* ({{this.graphData.TPDFuturePerc}}%) </div>
                            <div class="item-3" v-if="this.graphData.TPDDisabilityCoin > 0"><span class="swatch"></span>Medical needs and disability expenses ({{this.graphData.TPDDisabilityPerc}}%) </div>
                            <div class="item-2" v-if="this.graphData.TPDDebtCoin > 0"><span class="swatch"></span>Debts expenses ({{this.graphData.TPDDebtPerc}}%) </div>
                            <div class="item-1" v-if="this.graphData.TPDMortgageCoin > 0"><span class="swatch"></span>Mortgage expenses ({{this.graphData.TPDMortgagePerc}}%)</div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-3 mb-3">
                        <small>
                          <strong>Income supplement*</strong> - {{100-editAssumptions.incomeProtectionPercentage}}%  of income net of tax may be covered by TPD cover, the remaining {{editAssumptions.incomeProtectionPercentage}}%  may be covered by Income Protection.
                        </small>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-3 tabindex="0" variant="result">
                  <div class="title">Income protection</div>
                  <div class="number" v-if="this.engineResults.IncomeProtectionInsurance && this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month > 0">${{formatCurrency(Math.round((this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month * 12) + (this.engineResults.IncomeProtectionInsurance.BenefitLevel_Superannuation_per_month * 12)), true)}}</div>
									<div class="number" v-if="this.engineResults.IncomeProtectionInsurance && this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month <= 0">$0</div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-3" class="d-print-block" v-if="this.engineResults.IncomeProtectionInsurance" accordion="my-accordion" role="tabpanel"  v-bind:class="{ 'hide-graph': this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month * 12 <= 0 }">
                <b-card-body>
                  <b-card-text>
                    <p class="no-insurance-summary" v-html="pageContent.pages.results.incomeProtectionCoverNotRequiredSummary"></p>
                    <div class="insurance-summary">
                      <p>{{(pageContent.pages.results.incomeProtectionCoverSummary)}}</p>
                      <div class="row">
                        <div class="col-6">
                          <div class="coin-wrapper" aria-hidden="true">
                            <div class="progress">
                              <div class="progress-bar bg-none" role="progressbar"></div>
                              <div class="progress-bar bg-legend-1" role="progressbar" v-for="n in Math.round(editAssumptions.incomeProtectionPercentage/10)" :key="'ipp'+n"></div>
                              <div class="progress-bar bg-legend-6" role="progressbar" v-for="n in Math.round(10 - (editAssumptions.incomeProtectionPercentage/10))" :key="'ipp2'+n"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 legend-wrapper">
							<div class="legend">
								<div class="item-1"><span class="swatch"></span>{{editAssumptions.incomeProtectionPercentage}}% of current income <br>
									(+ <span v-html="pageContent.pages.results.ipPercentagePrefix"></span> {{editAssumptions.incomeProtectionSuperGuarantee}}% super)
									<span>
										<b-button id="tooltip-assumptions-ip" variant="tooltip" aria-label="tooltip assumptions income protection"><i class="icon-help"></i></b-button>
										<b-tooltip target="tooltip-assumptions-ip" placement="top">
											<span v-html="pageContent.pages.results.ipPercentageTooltip"></span>
										</b-tooltip>
									</span>
								</div>
							</div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

			<button class="link print-button col d-print-none " onclick="window.print();">
				<i class="icon-print"> </i>Print results
			</button>


          <div class="nav-button row d-print-none">
            <router-link class="assumption-button col " :to="{ name: 'Assumptions', params: {activeTab: 'assumptions' } }" tabindex="0" role="button"><i class="icon-edit"></i> Edit assumptions </router-link>
            <router-link class="back-button col" to="/expenses" tabindex="0" role="button">Back</router-link>
            <router-link class="next-button col" to="/next" tabindex="0" role="button">Find out more</router-link>
          </div>

        </div>
      </div>
    </div>
	<CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomFooter from '../components/CustomFooter';

export default {
  name: 'Results',
  components: {CustomFooter},
	computed: {
		...mapActions(["getEngineResults"]),
		...mapGetters(["engineResults","editAssumptions", "pageContent", "Enum", "data", "dependants", "debts", "expenses", "assets", "detailedExpenses"]),
	},
	mounted() {
		console.log('results');
		this.getEngineResults;

		// Graph
		this.graphData = {
			DeathFuneralExpenses:0, DeathLivingExpenses:0, DeathEducationExpenses:0, DeathDebtExpenses:0, TPDDisabilityExpenses:0, TPDFutureIncome:0, TPDDebtExpenses:0, TPDMortgageExpenses:0, DeathFuneralCoin:0, DeathLivingCoin:0, DeathEducationCoin:0, DeathDebtCoin:0, TPDDisabilityCoin:0, TPDFutureCoin:0, TPDDebtCoin:0, TPDMortgageCoin:0, DeathFuneralPerc:0, DeathLivingPerc:0, DeathEducationPerc:0, DeathDebtPerc:0, TPDDisabilityPerc:0, TPDFuturePerc:0, TPDDebtPerc:0, TPDMortgagePerc:0, TotalDeathCover:0, TotalTPDCover:0
		};

		function getTotal(myExpenses) {
			let myTotal = 0
			if(myExpenses){
				for(var i = 0, len = myExpenses.length; i < len; i++) {
					myTotal += myExpenses[i].ContributionToInsuranceNeed;
				}
			}
			return myTotal;
		}

		function getCoin (myExpenses, myTotalExpenses){
			let perc = 0;
			if(myExpenses){
				perc = myExpenses / myTotalExpenses * 100;

				if(perc > 0 && perc < 15) {
					return 1
				}
				else if(perc > 14 && perc < 25) {
					return 2
				}
				else if(perc > 24 && perc < 35) {
					return 3
				}
				else if(perc > 34 && perc < 45) {
					return 4
				}
				else if(perc > 44 && perc < 55) {
					return 5
				}
				else if(perc > 54 && perc < 65) {
					return 6
				}
				else if(perc > 64 && perc < 75) {
					return 7
				}
				else if(perc > 74 && perc < 85) {
					return 8
				}
				else if(perc > 84 && perc < 95) {
					return 9
				}
				else if(perc > 94)  {
					return 10
				}
			}
		}

		function getPercentage (myExpenses, myTotalExpenses){
			let calculatedPercentage = 0;
			if(myExpenses){
				calculatedPercentage = (myExpenses / myTotalExpenses * 100).toFixed(2);
			}
			return calculatedPercentage;
		}


		// Life insurance
		this.graphData.DeathFuneralExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Immediate expense"))
		this.graphData.DeathLivingExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Living")) + getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Rent"));
		this.graphData.DeathEducationExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Name === "Education costs"));
		this.graphData.DeathDebtExpenses = getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Debt")) + getTotal(this.engineResults.LifeInsurance.LiabilitiesToMeet.filter(o => o.Type === "Repay mortgage"));
		this.graphData.TotalDeathCover = this.graphData.DeathFuneralExpenses + this.graphData.DeathLivingExpenses + this.graphData.DeathEducationExpenses + this.graphData.DeathDebtExpenses;
		// TPD insurance
		this.graphData.TPDDisabilityExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Immediate expense"));
		this.graphData.TPDFutureIncome = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Future income"));
		this.graphData.TPDDebtExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Debt"));
		this.graphData.TPDMortgageExpenses = getTotal(this.engineResults.TPDInsurance.LiabilitiesToMeet.filter(o => o.Type === "Repay mortgage"));
		this.graphData.TotalTPDCover = this.graphData.TPDDisabilityExpenses + this.graphData.TPDFutureIncome + this.graphData.TPDDebtExpenses + this.graphData.TPDMortgageExpenses;
		// Coin calculation
		this.graphData.DeathFuneralCoin = getCoin(this.graphData.DeathFuneralExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathLivingCoin = getCoin(this.graphData.DeathLivingExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathEducationCoin =  getCoin(this.graphData.DeathEducationExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathDebtCoin =   getCoin(this.graphData.DeathDebtExpenses,this.graphData.TotalDeathCover);
		this.graphData.TPDDisabilityCoin =  getCoin(this.graphData.TPDDisabilityExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDFutureCoin =  getCoin(this.graphData.TPDFutureIncome,this.graphData.TotalTPDCover);
		this.graphData.TPDDebtCoin =   getCoin(this.graphData.TPDDebtExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDMortgageCoin =  getCoin(this.graphData.TPDMortgageExpenses,this.graphData.TotalTPDCover);
		// % calculation
		this.graphData.DeathFuneralPerc = getPercentage(this.graphData.DeathFuneralExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathLivingPerc = getPercentage(this.graphData.DeathLivingExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathEducationPerc =  getPercentage(this.graphData.DeathEducationExpenses,this.graphData.TotalDeathCover);
		this.graphData.DeathDebtPerc =   getPercentage(this.graphData.DeathDebtExpenses,this.graphData.TotalDeathCover);
		this.graphData.TPDDisabilityPerc =  getPercentage(this.graphData.TPDDisabilityExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDFuturePerc =  getPercentage(this.graphData.TPDFutureIncome,this.graphData.TotalTPDCover);
		this.graphData.TPDDebtPerc =   getPercentage(this.graphData.TPDDebtExpenses,this.graphData.TotalTPDCover);
		this.graphData.TPDMortgagePerc =  getPercentage(this.graphData.TPDMortgageExpenses,this.graphData.TotalTPDCover);

		// send analytics
    // results page
		this.$gtag.event("step-results", {
			"event_category": "result-data",
			"event_label": "death cover",
			"value": this.engineResults.LifeInsurance.LifeInsuranceNeed
		})
		this.$gtag.event("step-results", {
			"event_category": "result-data",
			"event_label": "TPD cover",
			"value": this.engineResults.TPDInsurance.TPDInsuranceNeed
		})
		this.$gtag.event("step-results", {
			"event_category": "result-data",
			"event_label": "IncomeProtection",
			"value": (this.engineResults.IncomeProtectionInsurance.BenefitLevel_Income_per_month * 12) + (this.engineResults.IncomeProtectionInsurance.BenefitLevel_Superannuation_per_month * 12)
		})

		// calculate total living expenses
		var total = 0;
		if(this.detailedExpenses) {
			this.expenses.forEach(expense => {
				total += expense.Amount;
			})
		}
		else {
			total = this.data.stepData.expensesAmountPerMonth;
		}
		this.livingExpenses = total;

    this.triggerHeightCheck();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);

    // add click function for accordions
    document.querySelectorAll(".btn-result").forEach(accordionBtn =>
      accordionBtn.addEventListener('click', this.triggerSlowHeightCheck)
    );
	},
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
	data() {
		return {
			graphData:0,
			livingExpenses: 0,
		};
	},
	methods: {
		formatCurrency: (value, noCents = false) => {
		return value === null
			? ""
			: noCents
			? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			: parseFloat(value)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
    triggerSlowHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 800);
    }
	},
}


</script>
